import { useState, useEffect } from "react";
import { siteData } from "../data/mock";
import { Menu, X, MessageCircle } from "lucide-react";

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Início", href: "#inicio" },
    { label: "Sobre", href: "#sobre" },
    { label: "Especialidades", href: "#especialidades" },
    { label: "Invisalign", href: "#invisalign" },
    { label: "Contato", href: "#contato" },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-white shadow-md"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-[72px]">
          {/* Logo */}
          <a href="#inicio" onClick={(e) => scrollToSection(e, "#inicio")} className="flex flex-col leading-tight">
            <span
              className="text-lg font-bold tracking-tight"
              style={{ color: isScrolled ? '#1F1F1F' : '#FEFEFE', fontFamily: "'Inter', sans-serif" }}
            >
              Dra. Giovana Gamborgi
            </span>
            <span
              className="text-[11px] font-semibold tracking-[0.15em] uppercase"
              style={{ color: '#85BCFF' }}
            >
              Odontologia que transforma
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-7">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="text-[13px] font-medium transition-colors duration-200 hover:opacity-75"
                style={{ color: isScrolled ? '#1F1F1F' : '#FEFEFE' }}
              >
                {link.label}
              </a>
            ))}
            <a
              href={siteData.brand.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-6 py-2.5 rounded-lg text-sm font-bold transition-all duration-200 hover:scale-105 hover:shadow-lg"
              style={{ backgroundColor: '#85BCFF', color: '#1F1F1F' }}
            >
              <MessageCircle size={16} />
              Agendar Consulta
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2"
            style={{ color: isScrolled ? '#1F1F1F' : '#FEFEFE' }}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen ? "max-h-[400px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="bg-white px-4 py-5 shadow-lg">
          <nav className="flex flex-col gap-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="text-sm font-medium py-2 text-slate-700"
              >
                {link.label}
              </a>
            ))}
            <a
              href={siteData.brand.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 px-5 py-3 rounded-lg text-sm font-bold mt-2 transition-all"
              style={{ backgroundColor: '#85BCFF', color: '#1F1F1F' }}
            >
              <MessageCircle size={16} />
              Agendar Consulta
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};
